import studentApi from "./studentApi";
import { STUDENT_ENDPOINTS } from "./studentEndpoints";

export const getAppointments = async (params) => {
  const response = await studentApi.get(STUDENT_ENDPOINTS.APPOINTMENT.GET, { params });
  return response;
};

export const createAppointment = async (payload) => {
  const response = await studentApi.post(STUDENT_ENDPOINTS.APPOINTMENT.CREATE, payload);
  return response;
};

// Confirmed against the shipping mobile app's API client (2026-10-22):
// cancel sends { status: 4 } (4 = Cancelled, per the client's own mapping).
export const cancelAppointment = async (appointmentId) => {
  const response = await studentApi.post(`${STUDENT_ENDPOINTS.APPOINTMENT.CANCEL}/${appointmentId}/cancel`, {
    status: 4,
  });
  return response;
};

// Not exposed in the student-facing UI (not shown in the real screens this
// was built from — only "Cancel" appears there), kept here for completeness
// since the route exists under the student prefix.
export const confirmAppointment = async (appointmentId, payload) => {
  const response = await studentApi.post(
    `${STUDENT_ENDPOINTS.APPOINTMENT.CONFIRM}/${appointmentId}/confirm`,
    payload
  );
  return response;
};

export const rescheduleAppointment = async (appointmentId, payload) => {
  const response = await studentApi.post(
    `${STUDENT_ENDPOINTS.APPOINTMENT.RESCHEDULE}/${appointmentId}/reschedule`,
    payload
  );
  return response;
};

export const getMeetingWithTypes = async (params) => {
  const response = await studentApi.get(STUDENT_ENDPOINTS.MEETING_WITH_TYPES.GET, { params });
  return response;
};
